import en from 'vuetify/es5/locale/en'
import icons from '~/config/vuetify.icons'

const vuetifyOptions = {
  theme: {
    light: true,
    themes: {
      light: {
        uiInputInfoTooltipColor: '#147bd1',
        uiSelectItemBgColor: '#edf3f7',
        uiTooltipBgColorBlue: '#d3e2ec',
        chartColumnColor: '#147bd1',
        chartColumnColorLight: '#D3E2EC',
        chartSplineColor: '#d3e2ec',
        chartMarkerColor: '#147bd1',
        chartMarkerFillColor: '#147bd1',
        chartMarkerLineColor: '#d3e2ec',
        chartColorLight: '#d3e2eC',
        chartColorDark: '#8ac1ef',
        chartSplineLightColor: '#aeb5c9',
        chartColorRed: '#ef6461',
        welcomeDialogOverlayColor: '#1f1f1f',
      },
    },
    options: {
      customProperties: true,
      variations: false,
    },
  },
  lang: {
    locales: { en },
    current: 'en',
  },
  icons: {
    iconfont: false,
    values: icons,
  },
}

export default vuetifyOptions
